import React from 'react';
import { Box, Typography, Avatar, Rating, Divider, TableCell, Grid } from '@mui/material';

export const TableCellRenderer = ({ children, ...rest }) => (
  <TableCell
    style={{
      fontSize: '13px',
      fontWeight: '500',
      textAlign: 'center',
      verticalAlign: 'top',
      whiteSpace: 'pre-wrap'
    }}
    {...rest}
  >
    {children}
  </TableCell>
);

export const ImageCell = ({ images, image }) => {
  if (!image?.state?.mainImage) return <TableCellRenderer />;
  const imageIds = Array.isArray(image.state.mainImage)
    ? image.state.mainImage
    : [image.state.mainImage];
  return (
    <TableCellRenderer>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
        {imageIds.map((id) => (
          <Avatar
            key={id}
            src={images[id] || ''}
            sx={{ width: 60, height: 60, border: '2px solid #e0e0e0' }}
            variant="rounded"
          />
        ))}
      </Box>
    </TableCellRenderer>
  );
};

export const ParagraphCell = ({ paragraph }) => (
  <TableCellRenderer>
    <div dangerouslySetInnerHTML={{ __html: paragraph?.state?.mainContent || '' }} />
  </TableCellRenderer>
);

export const TextCell = ({ value }) => (
  <TableCellRenderer>{value || ""}</TableCellRenderer>
);

export const RatingCell = ({ rating }) => (
  <TableCellRenderer>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
      <Rating value={rating || 0} readOnly />
      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
        {`${rating || 0}/5`}
      </Typography>
    </Box>
  </TableCellRenderer>
);

export const ProductListCell = ({ productList }) => {
  if (!productList?.mainProducts) return <TableCellRenderer />;
  return (
    <TableCellRenderer>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        p: 2
      }}>
        {productList.mainProducts.map((product, index) => (
          <React.Fragment key={index}>
            <Box sx={{
              display: 'flex',
              flexDirection:'column',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              p: 1
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0.5 , mb:'8px' }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#1a237e' }}>
                  {'نام محصول:'}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#1a237e' }}>
                  {product.name}
                </Typography>
              </Box>
              <Box sx={{ textAlign: 'end' , display:'flex' , flexDirection:'row-reverse' , alignItems:"center" , gap:'4px' }}>
                <Typography variant="subtitle1" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>
                  {product.price} تومان
                </Typography>
                <Typography variant="subtitle1" sx={{ color: '#666' }}>
                  تعداد: {product.quantity} /
                </Typography>
              </Box>
            </Box>
            {index < productList.mainProducts.length - 1 && <Divider sx={{ my: 1 }} />}
          </React.Fragment>
        ))}
        <Box sx={{
          mt: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#e8f5e9',
          p: 1.5,
          borderRadius: '4px'
        }}>
          <Typography variant="subtitle2" sx={{ color: '#666' }}>
            تعداد کل: {productList.totalQuantity}
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
            جمع کل: {productList.totalPrice} تومان
          </Typography>
        </Box>
      </Box>
    </TableCellRenderer>
  );
};

export const FillInTheBlankCell = ({ fillData }) => (
  <TableCellRenderer>
    <Box sx={{ display: 'inline' }}>
      {fillData?.state?.inputs?.map((input) => (
        <Typography
          key={input.id}
          component="span"
          sx={{
            color: input.color || 'inherit',
            fontSize: `${input.fontSize || 12}px`,
            fontWeight: input.bold ? 'bold' : 'normal',
            fontStyle: input.italic ? 'italic' : 'normal',
            textDecoration: input.underline ? 'underline' : 'none'
          }}
        >
          {input.value}
        </Typography>
      ))}
    </Box>
  </TableCellRenderer>
);

export const TableRatingCell = ({ tableData }) => (
  <TableCellRenderer>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'center' }}>
      {tableData?.mainSelectedColumnIndex?.map((item, index) => (
        <Grid display={'flex'} alignItems={'center'} gap={'4px'} key={index}>
          <Typography fontSize={'12px'} fontWeight={'700'}>{item.row}:</Typography>
          <Typography fontSize={'12px'} fontWeight={'500'}>{item.column}</Typography>
        </Grid>
      ))}
    </Box>
  </TableCellRenderer>
);
